/* tslint:disable */
import type * as ApiTypes from '@ogm3/server-types';
import * as Fetch from '../../fetch';
import type * as Actions from '../../async-actions';

// MetaProductController

/**
 * Authorize: Policy = "EditMetaProduct"
 */
export function DeleteMetaProducts(
	args: ApiTypes.DeleteMetaProductsArgs
): Promise<Actions.ApiResult<ApiTypes.DeleteMetaProductsResult>> {
	const uri = `/api/v3/delete-metaproducts`;
	const config: Fetch.RequestConfig = {
		uri,
		method: 'POST',
		body: JSON.stringify(args),
	};
	return Fetch.fetch2<ApiTypes.DeleteMetaProductsResult>(config);
}
